module.exports = __webpack_public_path__ + "static/media/back-common.027a4fb1.svg";